import type React from 'react'

interface StepperProps {
  currentStep: number
  steps: string[]
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps }) => {
  return (
    <div className="w-full">
      <div className="relative flex justify-between items-center">
        {/* The connecting line container */}
        <div
          className="absolute top-4 h-0.5"
          style={{
            left: '16px',
            width: 'calc(100% - 64px)',
          }}
        >
          {/* The gray background line */}
          <div className="w-full h-full bg-gray-300" />
          {/* The blue progress line */}
          <div
            className="absolute top-0 left-0 h-full bg-blue-600"
            style={{
              width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
              transition: 'width 0.3s ease-in-out',
            }}
          />
        </div>

        {/* The step markers */}
        {steps.map((step, index) => (
          <div key={step} className="relative z-10 flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors duration-300 ${
                index + 1 <= currentStep
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-300 text-white'
              }`}
            >
              {index + 1}
            </div>
            <p
              className={`mt-2 text-xs text-center transition-colors duration-300 ${
                index + 1 <= currentStep ? 'text-gray-900' : 'text-gray-500'
              }`}
            >
              {step}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Stepper
